export default "__VITE_ASSET__jBO$NH7k__"